<template>
	<div class="detail">
		<div class="header">
			<el-row>
				<el-col :span="13" class="flex flex-align-center">
					<p class="PingFang">
						{{ row.activity_name }}
					</p>
					<p
						v-if="$auth.hasPermi('system:myActivities:copyLink')"
						class="fz-14 hover PingFang pointer ml-20"
						@click="copyActivityId(row.activity_url)"
					>
						<i class="el-icon-document-copy mr-4"></i>
						<span>复制报名链接</span>
					</p>
				</el-col>
			</el-row>
			<single :row="row"></single>
		</div>
		<div class="line mt-20 mb-14"></div>
		<div class="search mt-30 mb-30">
			<search :tabName="tabName" @onSubmit="onSubmit"></search>
		</div>
		<div class="multi-table">
			<updateTime :type="sync_type" ref="updateTime" @updateList="updateList"></updateTime>
			<el-tabs @tab-click="handleClick" v-model="tabName">
				<el-tab-pane v-for="(item, index) in tableArr" :name="`${item.audit_status}`" :key="index">
					<div slot="label" class="flex flex-align-center">
						<span class="mr-6">{{ item.audit_status_desc }}</span>
						<span class="mr-6">{{ item.num || '0' }}</span>
						<el-tooltip
							effect="dark"
							:content="
								index === 2
									? '报名申请被团长拒绝的商品将展示在这里，部分商品允许重新报名'
									: '商家可以申请中途退出团长招商，退出成功的商品将展示在这里'
							"
						>
							<i v-if="index === 2 || index === 3" class="iconfont icon-a-help-circle-obangzhu-xian yx-color-info"></i>
						</el-tooltip>
					</div>
					<div class="tab">
						<div class="flex flex-align-center">
							<div class="ml-14 mr-18 font-h5-regular">
								已选
								<span class="color-p-4">{{ selectionShopArr.length || 0 }}</span>
							</div>
							<div class="export">
								<template v-if="(isShopPartnerDataView || isAllDataView) && $auth.hasPermi('system:myActivities:commodityAudit') && tabName === '0'">
									<el-tooltip placement="top" :disabled="!!selectionShopArr.length" content="至少选择一条数据">
										<el-button @click="batchFun('0')" type="primary">通过</el-button>
									</el-tooltip>
									<el-tooltip placement="top" :disabled="!!selectionShopArr.length" content="至少选择一条数据">
										<el-button @click="batchFun('1')" type="primary">拒绝</el-button>
									</el-tooltip>
								</template>
								<el-button @click="exportFun" :loading="exportLoading">导出数据</el-button>
							</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			<multi-table
				v-loading="loading"
				element-loading-text="加载中"
				element-loading-background="rgba(255, 255, 255)"
				ref="multiTable"
				:columns="columns"
				@gePartnerList="gePartnerList"
				:list="list"
				:options="options"
				:total="total"
				:selectionChange="selectionChange"
			>
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</div>
		<AuditPass ref="auditPass" @refreshList="refreshList" />
		<AuditReject ref="auditReject" @refreshList="refreshList" />
	</div>
</template>
<script>
import single from '../../components/single.vue';
import updateTime from '../../components/updateTime.vue';
import search from './components/dySearch.vue';
import { activitySync, activityDetail, activityList, exportActivityList, auditActivity } from '@/api/secondColonelManage';
import { copy, copyFun } from '@/utils/common';
import { columns } from './dyColumns';
import { mapGetters } from 'vuex';
import empty from '@/views/common/empty/index.vue';
import { PLATFORM_DY, activityType, dyMyActivityUpStateList } from '@/utils/dataMap';
import AuditPass from './components/auditPass.vue';
import AuditReject from './components/auditReject.vue';
import { getAuditConfig } from '@/api/settings.js';
export default {
	name: 'detail',
	components: {
		search,
		single,
		updateTime,
		empty,
		AuditPass,
		AuditReject,
	},
	data() {
		return {
			tableArr: dyMyActivityUpStateList,
			row: {},
			tabName: '0',
			sync_type: activityType.myActivityGoods,
			params: {
				page_index: 1,
				page_size: 10,
			},
			list: [],
			selectionShopArr: [],
			content: '',
			options: { selectable: true },
			columns,
			total: '0',
			loading: true,
			exportLoading: false,
			isSearch: false,
			PLATFORM_DY: PLATFORM_DY.value,
			productAuditClaim: 0,
		};
	},
	created() {
		this.activityDetail();
		this.getAuditConfigInfo();
	},
	mounted() {
		const { tabName, activity_id, PLATFORM_DY, third_activity_id } = this;
		this.activityList(tabName, activity_id);
		this.$refs.updateTime.getSyncTime(third_activity_id, PLATFORM_DY);
	},
	computed: {
		...mapGetters(['isShopPartnerDataView', 'isAllDataView', 'isDarenPartner']),
		activity_id() {
			return this.$route.query.id;
		},
		third_activity_id() {
			return this.$route.query.third_activity_id;
		},
		team_institution_id() {
			const { institution_info = {} } = this;
			return institution_info.team_institution_id || '';
		},
		authorityId() {
			return this.$route.query.authority_id;
		},
		// 全部视角来判断
		auitContent() {
			return this.isAllDataView ? '通过后请去商品管理-团长商品手动分配' : '通过后请去商品管理-团长商品手动认领';
		},
	},
	methods: {
		batchFun(value) {
			if (!this.selectionShopArr.length) return;
			if (this.selectionShopArr.length > 100) {
				return this.$message.error('批量审核的商品数不可超过100个');
			}
			const rows = this.selectionShopArr.filter(item => !item.forbidden_user_follow);
			if (rows.length === 0) {
				this.$message.warning('未选择可审核商品');
				return;
			}
			let content = `<span>已选</span><span style="color: #2475FF" class="mr-4 ml-4">${rows.length}</span><span>个待审核商品，</span>通过后将分配给指定的招商运营，未选择则不进行分配`;
			if (!this.$auth.hasPermi('system:myActivities:distributeGoods') && this.productAuditClaim) {
				content = `<span>已选</span><span style="color: #2475FF" class="mr-4 ml-4">${rows.length}</span><span>个待审核商品，</span>通过后将自动认领商品`;
			}
			if (!this.$auth.hasPermi('system:myActivities:distributeGoods') && !this.productAuditClaim) {
				content = `<span>已选</span><span style="color: #2475FF" class="mr-4 ml-4">${rows.length}</span><span>个待审核商品，</span>确认审核商品？`;
			}
			if (value == 0) {
				this.$refs.auditPass.show(rows, content, true);
			} else {
				this.$refs.auditReject.show(rows, `已选${rows.length}个待审核商品，拒绝后将不可恢复，确认要操作吗？`);
			}
		},
		handleClick() {
			const { tabName, activity_id } = this;
			this.params.page_index = 1;
			this.activityList(tabName, activity_id);
		},
		async activityDetail() {
			const { activity_id, PLATFORM_DY: platform_id } = this;
			const { code, data } = await activityDetail({ activity_id, platform_id });
			if (code !== 0) return;
			this.row = data;
		},
		async updateList() {
			const { third_activity_id: item_id, sync_type: type, PLATFORM_DY: platform_id, authorityId: authority_id } = this;
			const { code } = await activitySync({ item_id, type, platform_id, authority_id });
			if (code !== 0) return;
			this.$message({
				iconClass: 'el-icon-info primary mr-10',
				message: '商品正在同步...',
			});
		},
		copyActivityId(val) {
			copy(val);
			this.$message.success('复制成功');
		},
		async activityList(tabName, activity_id, isSearch = false) {
			this.isSearch = isSearch;
			this.loading = true;
			this.params.audit_status = tabName;
			this.params.activity_id = activity_id;
			this.params.authority_id = this.authorityId;
			const { code, data } = await activityList(this.params);
			if (code !== 0) return;
			this.list = data.list.map(item => {
				return {
					...item,
					operations: this.getButtons(item, tabName),
				};
			});
			this.tableArr = data.statistics;
			this.total = data.page.item_total + '';
			this.loading = false;
		},
		//操作按钮
		getButtons(item, tabName) {
			const { isShopPartnerDataView, isAllDataView } = this;
			let arr = [];
			arr.push(
				{
					label: '通过',
					type: 'text',
					classtype: 2,
					notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
					disabled: item.forbidden_user_follow,
					disabledTooltip: item.forbidden_user_follow,
					tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
					isShow: tabName === '0' && (isShopPartnerDataView || isAllDataView) && this.$auth.hasPermi('system:myActivities:commodityAudit'),
					click: row => {
						let content = '确认审核商品，通过后将分配给指定的招商运营，未选择则不进行分配';
						if (!this.$auth.hasPermi('system:myActivities:distributeGoods') && this.productAuditClaim) {
							content = '确认审核商品，通过后将自动认领商品';
						}
						if (!this.$auth.hasPermi('system:myActivities:distributeGoods') && !this.productAuditClaim) {
							content = '确认审核商品？';
						}
						this.$refs.auditPass.show(
							[
								{
									activity_id: row.activity_id,
									apply_id: row.apply_id,
									third_product_ids: row.third_product_id,
									product_id: row.product_id,
								},
							],
							content,
						);
					},
				},
				{
					label: '拒绝',
					type: 'text',
					classtype: 2,
					notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
					disabled: item.forbidden_user_follow,
					disabledTooltip: item.forbidden_user_follow,
					tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
					isShow: tabName === '0' && (isShopPartnerDataView || isAllDataView) && this.$auth.hasPermi('system:myActivities:commodityAudit'),
					click: row => {
						this.$confirm('是否确认拒绝?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						}).then(async () => {
							const { code } = await auditActivity({
								activity_id: row.activity_id,
								apply_ids: row.apply_id,
								operation: '1',
								third_product_id: row.third_product_id,
								product_id: row.product_id,
								authority_id: this.authorityId,
							});
							if (code !== 0) return;
							this.$message.success('操作成功');
							this.refreshList();
						});
					},
				},
				{
					label: '复制链接',
					type: 'text',
					disabledTooltip: true,
					tooltipContent: '专属链接，达人使用该链接带货产生的订单归属为您的业绩。',
					classtype: 2,
					isShow: tabName === '1',
					click: row => {
						copyFun(row, this);
					},
				},
			);

			return arr.filter(item => item.isShow);
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.$refs['multiTable'].resetPage();
			this.refreshList(true);
		},
		gePartnerList({ page_index, page_size }) {
			this.params.page_index = page_index;
			this.params.page_size = page_size;
			this.refreshList();
		},
		async exportFun() {
			try {
				this.exportLoading = true;
				const { download_url } = await exportActivityList(this.params);
				this.exportLoading = false;
				window.open(download_url, '_blank');
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
				this.exportLoading = false;
			}
		},
		refreshList(isSearch) {
			const { tabName, activity_id } = this;
			this.activityList(tabName, activity_id, isSearch);
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
		},
		// 获取商品审核设置
		async getAuditConfigInfo() {
			const { data, code } = await getAuditConfig({ platformId: this.PLATFORM_DY });
			if (code === 0) {
				this.productAuditClaim = data.productAuditClaim;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.line {
	height: 1px;
	background: #eeeeee;
}

.export {
	display: flex;
	justify-content: end;
	margin: 10px 0;
}
</style>
